import { ApolloClient, NormalizedCacheObject } from '@apollo/client/core';
import { FETCH_PROFILE_COMPLETE_PREVIEW } from '@/graphql/profile/queries';
import { Badge } from '@/components/sitter_badge_list/__types__/SitterBadgeListTypes';

export interface ProfileCompletePreviewData {
  yearsExperience: number;
  bio: string;
  qualifications: string[];
  minRate: number;
  maxRate: number;
}

export function qualificationsToBadges(qualifications: string[]): Badge[] {
  const badges: Badge[] = [];

  if (qualifications.includes('CPR_CERTIFIED')) {
    badges.push({ name: 'cpr_certified', status: 'COMPLETE' });
  }
  if (qualifications.includes('FIRST_AID_TRAINING')) {
    badges.push({ name: 'first_aid_training', status: 'COMPLETE' });
  }

  return badges;
}

const CARE_TYPE_PROFILE_KEYS: Record<string, string> = {
  babysitter: 'babysitter',
  nanny: 'nanny',
  petCare: 'petCare',
  housekeeping: 'housekeeping',
  companionCare: 'companionCare',
};

export function extractProfilePreview(profile: any): ProfileCompletePreviewData | null {
  if (!profile?.bio) return null;

  return {
    yearsExperience: profile.yearsExperience ?? 0,
    bio: profile.bio,
    qualifications: profile.qualifications ?? [],
    minRate: profile.payRate?.min ?? 0,
    maxRate: profile.payRate?.max ?? 0,
  };
}

interface ApolloQueryClient {
  query: ApolloClient<NormalizedCacheObject>['query'];
}

export async function fetchProfileCompletePreview(
  apolloClient: ApolloQueryClient,
  accountId: string,
  careType: string
): Promise<ProfileCompletePreviewData | null> {
  const profileKey = CARE_TYPE_PROFILE_KEYS[careType];
  if (!profileKey) return null;

  const { data } = await apolloClient.query({
    query: FETCH_PROFILE_COMPLETE_PREVIEW,
    variables: { accountId },
    fetchPolicy: 'network-only',
  });

  const profile = data?.account?.profiles?.[profileKey]?.profile;
  return extractProfilePreview(profile);
}
